// import React, { useEffect, useState } from 'react';
// import {Link} from 'react-router-dom';

// export default function UserDetailForm({setPopupVisible}) {

//   const [userDetails, setUserDetails] = useState({
//     first_name: '',
//     last_name: '',
//     Address: '',
//     phone: '',
//     email: '',
//     password: '',
//     confirm_password: '',
//     remember: false,
//   });


//   useEffect(()=>{
//     setPopupVisible(false);
//   },[])

//   const [errors, setErrors] = useState({});

//   const handleChange = (e) => {
//     const { id, value, type, checked } = e.target;
//     setUserDetails({
//       ...userDetails,
//       [id]: type === 'checkbox' ? checked : value,
//     });
//   };

//   const validateForm = () => {
//     let formErrors = {};
//     if (userDetails.password !== userDetails.confirm_password) {
//       formErrors.confirm_password = "Passwords do not match";
//     }
//     if (!userDetails.email.includes('@')) {
//       formErrors.email = "Invalid email address";
//     }
//     // Add more validations as required
//     setErrors(formErrors);
//     return Object.keys(formErrors).length === 0;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (validateForm()) {
//       console.log('Form Submitted', userDetails);

      
//       let data = JSON.parse(localStorage.getItem("userDetails"))
//       data["details"] = userDetails;
//       localStorage.setItem("userDetails", JSON.stringify(data));
//     //   let data2 = localStorage.getItem("userDetails")
//     //   console.log("hello ji sita Ram", data.name, data, data2)
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="bg-black px-[25%] py-10">
//       <div className="grid gap-6 mb-6 md:grid-cols-2">
//         <div>
//           <label htmlFor="first_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">First name</label>
//           <input
//             type="text"
//             id="first_name"
//             value={userDetails.first_name}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder="John"
//             required
//           />
//         </div>
//         <div>
//           <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Last name</label>
//           <input
//             type="text"
//             id="last_name"
//             value={userDetails.last_name}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder="Doe"
//             required
//           />
//         </div>
//         <div>
//           <label htmlFor="Address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Address</label>
//           <input
//             type="text"
//             id="Address"
//             value={userDetails.Address}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder="Flowbite"
//             required
//           />
//         </div>
//         <div>
//           <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Mobile number</label>
//           <input
//             type="tel"
//             id="phone"
//             value={userDetails.phone}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder="1234567890"
            
//             required
//           />
//         </div>
//         {/* <div>
//           <label htmlFor="website" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Website URL</label>
//           <input
//             type="url"
//             id="website"
//             value={userDetails.website}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder="flowbite.com"
//             required
//           />
//         </div> */}
//         {/* <div>
//           <label htmlFor="visitors" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Unique visitors (per month)</label>
//           <input
//             type="number"
//             id="visitors"
//             value={userDetails.visitors}
//             onChange={handleChange}
//             className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//             placeholder=""
//             required
//           />
//         </div> */}
//       </div>
//       <div className="mb-6">
//         <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email address</label>
//         <input
//           type="email"
//           id="email"
//           value={userDetails.email}
//           onChange={handleChange}
//           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//           placeholder="john.doe@Address.com"
//           required
//         />
//         {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
//       </div>
//       <div className="mb-6">
//         <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
//         <input
//           type="password"
//           id="password"
//           value={userDetails.password}
//           onChange={handleChange}
//           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//           placeholder="•••••••••"
//           required
//         />
//       </div>
//       <div className="mb-6">
//         <label htmlFor="confirm_password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Confirm password</label>
//         <input
//           type="password"
//           id="confirm_password"
//           value={userDetails.confirm_password}
//           onChange={handleChange}
//           className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
//           placeholder="•••••••••"
//           required
//         />
//         {errors.confirm_password && <p className="text-red-500 text-sm">{errors.confirm_password}</p>}
//       </div>
//       <div className="flex items-start mb-6">
//         <div className="flex items-center h-5">
//           <input
//             id="remember"
//             type="checkbox"
//             checked={userDetails.remember}
//             onChange={handleChange}
//             className="w-4 h-4 border border-gray-300 rounded bg-gray-50 focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800"
//             required
//           />
//         </div>
//         <label htmlFor="remember" className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
//           I agree with the <Link to="/conditions" className="text-blue-600 hover:underline dark:text-blue-500">terms and conditions</Link>.
//         </label>
//       </div>
//       <button
//         type="submit"
//         className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
//       >
//         Submit
//       </button>
//     </form>
//   );
// }



// ------------------------------
// import React, { useState } from 'react';

// const FloatingLabelInput = ({ name, label, type }) => {
//   const [isActive, setIsActive] = useState(false);

//   const handleFocus = () => setIsActive(true);
//   const handleBlur = (event) => setIsActive(event.target.value !== '');

//   return (
//     <div className="relative mb-4">
//       <input
//         className={[
//           "outline-none w-full rounded bg-gray-100 text-sm px-3 py-2 transition-all duration-200 ease-in-out",
//           isActive ? "border border-blue-500" : "border border-gray-300",
//         ].join(" ")}
//         id={name}
//         name={name}
//         type={type}
//         onFocus={handleFocus}
//         onBlur={handleBlur}
//       />
//       <label
//         className={[
//           "absolute top-2 left-3 text-gray-400 text-sm pointer-events-none transition-all duration-200 ease-in-out",
//           isActive ? "text-blue-500 transform translate-y-[-1.5rem] scale-0.75" : "",
//         ].join(" ")}
//         htmlFor={name}
//       >
//         {label}
//       </label>
//     </div>
//   );
// };

// const UserDetailForm = () => {
//   return (
//     <form className="space-y-4">
//       <FloatingLabelInput name="name" label="Name" type="text" />
//       <FloatingLabelInput name="email" label="Email" type="email" />
//       <FloatingLabelInput name="message" label="Message" type="textarea" />
//       <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded">
//         Submit
//       </button>
//     </form>
//   );
// };

// export default UserDetailForm;

// ---------------------------
import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { autho } from '../database/firebase';

export default function UserDetails({ setPopupVisible }) {
  useEffect(() => { setPopupVisible(false); }, []);



  let userData = JSON.parse(localStorage.getItem("userDetails"));

  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
    
    // console.log(formValues)
  };


  const signIn = async()=>{
    
    try{
        const user = signInWithEmailAndPassword(autho, formValues.email, formValues.password)  ;
        return false;
    }
      
    catch(e)
    {
      return true;
    }
  }

  
  const handleSubmit = async (e) => {
    
    e.preventDefault();

    if (formValues['password'] !== formValues['confirmPassword']) {
      setFormValues({ ...formValues, password: '' });
      setFormValues({ ...formValues, confirmPassword: '' });
  
      return alert('Passwords do not match. Enter password again');
    }
  
    try {
      // let safe = await signIn();
  
      // if (safe) {
        await createUserWithEmailAndPassword(autho, formValues['email'], formValues['password']); 
        let uri = process.env.REACT_APP_Realtime_Firebase;
        let response = await fetch(uri + 'userAuthData.json', {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
    
          body: JSON.stringify(formValues)
        })
        
  
        // console.log('Successfully stored.');
        setFormValues({
          firstName: '',
          lastName: '',
          email: '',
          password: '',
          confirmPassword: ''
        });
        
        let data = JSON.parse(localStorage.getItem("userDetails"))
        data["name"] = formValues.firstName + " " + formValues.lastName;
        localStorage.setItem("userDetails", JSON.stringify(data));
        alert('userRegistered sucessfully.')
        navigate('/');
      // } else {
      //   alert('User already registered.');
      // }
    } catch (e) {
      alert('User already registered.');
      // console.log('Something went wrong.', e);
    }


  };

  const BackButton = () => {
    if (!userData['name']) {
      setPopupVisible(true);
    }
    navigate('/');
  };

  return (
    
    <div className="bg-gray-800 p-6 h-screen">
      <form className="max-w-md mx-auto bg-gray-900 p-6 rounded-lg shadow-lg" onSubmit={handleSubmit}>
        <div className="grid md:grid-cols-2 md:gap-6">
          <div className="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="firstName"
              id="floating_first_name"
              className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
              value={formValues.firstName}
              onChange={handleChange}
            />
            <label htmlFor="floating_first_name" className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">First name</label>
          </div>
          <div className="relative z-0 w-full mb-5 group">
            <input
              type="text"
              name="lastName"
              id="floating_last_name"
              className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
              placeholder=" "
              required
              value={formValues.lastName}
              onChange={handleChange}
            />
            <label htmlFor="floating_last_name" className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Last name</label>
          </div>
        </div>
        <div className="relative z-0 w-full mb-5 group">
          <input
            type="email"
            name="email"
            id="floating_email"
            className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required
            value={formValues.email}
            onChange={handleChange}
          />
          <label htmlFor="floating_email" className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Email address</label>
        </div>
        <div className="relative z-0 w-full mb-5 group">
          <input
            type="password"
            name="password"
            minLength={7}
            id="floating_password"
            className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required
            value={formValues.password}
            onChange={handleChange}
          />
          <label htmlFor="floating_password" className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Password</label>
        </div>
        <div className="relative z-0 w-full mb-5 group">
          <input
            type="password"
            name="confirmPassword"
            minLength={7}
            id="floating_repeat_password"
            className="block py-2.5 px-0 w-full text-sm text-white bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
            placeholder=" "
            required
            value={formValues.confirmPassword}
            onChange={handleChange}
          />
          <label htmlFor="floating_repeat_password" className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6">Confirm password</label>
        </div>
        <div className="flex justify-evenly">
          <Link to='/' onClick={BackButton} className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Back</Link>
          <button type="submit" className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">Submit</button>
        </div>
      </form>
    </div>
  );
}
